(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('forgotPasswordController', Controller);
    Controller.$inject = [
        'Login',
        'Routing'
    ];

    function Controller (
        Login,
        Routing
    ) {

        var vm = this;

        vm.showProgress = false;
        vm.error = null;
        vm.success = null;

        vm.email = null;



        vm.onSubmit = function() {
            vm.error = null;
            vm.success = null;

            if (!vm.email) {
                vm.error = "Please enter your email address";
                return;
            }

            vm.showProgress = true;

            Login.resetPassword(vm.email).then(function(success) {
                vm.showProgress = false;

                if (success) {
                    vm.success = "A message containing your new password has been sent to the email address indicated.";
                    vm.email = null;

                } else {
                    vm.error = 'Password reset failed. Please make sure you entered the correct email address.';
                }

            }).catch(function() {
                vm.error = 'Unknown failure.';
            });
        };



        vm.onCancel = function() {
            Routing.start();
        };



        //----------- initialization ------------------

        function init() {
        }


        init();


    }



})();
